// extracted by mini-css-extract-plugin
module.exports = {"container":"_1klXSbL2jsjkXk6UZ48t5m","cancelBtn":"Nfe2I2j7Hziily0Z6mc5","icon":"npkpkMW4bzvQ_N9OKbdXi","saveBtn":"_1vVa3BSRazwKNPqJ6pCVKE"};